module.exports = __webpack_public_path__ + "img/siwei-shuoming.3a24993a.jpg";